import classNames from "classnames";
import range from "lodash/range";
import { useTheme } from "PFApp/theme_context_provider/theme_context_provider_context";
import { CircleSize, CircleSizeTable } from "PFComponents/loading_dots/loading_dots.utils";
import { Color } from "PFCore/types";

import css from "./loading_dots.module.scss";

type SingleDotProps = {
  circlesEnabled: boolean;
  circleSize: CircleSize;
};

const SingleDot = ({ circlesEnabled, circleSize }: SingleDotProps) => {
  const sizeValue = CircleSizeTable[circleSize];
  return (
    <span
      style={circlesEnabled ? { width: sizeValue, height: sizeValue } : {}}
      className={classNames(css.loadingDotsElement, {
        [css.loadingDotsCircle]: circlesEnabled
      })}
    >
      {!circlesEnabled && "."}
    </span>
  );
};

type CommonProps = {
  pageViewEnabled?: boolean;
  centered?: boolean;
  className?: string;
  qaId?: string;
  color?: Color;
};

type ConditionalProps =
  | {
      circlesEnabled: true;
      circleSize?: CircleSize;
    }
  | {
      circlesEnabled?: false;
      circleSize?: never;
    };

type LoadingDotsProps = CommonProps & ConditionalProps;

export const LoadingDots = ({
  circlesEnabled,
  pageViewEnabled,
  circleSize = "md",
  centered = false,
  className,
  color,
  qaId = "loading-dots"
}: LoadingDotsProps) => {
  const { themeVars } = useTheme();
  const wrapperStyle = color ? { color: themeVars[color] } : undefined;

  return (
    <div
      role="progressbar"
      aria-busy="true"
      className={classNames(css.loadingDots, className, {
        [css.centered]: centered || pageViewEnabled,
        [css.pageView]: pageViewEnabled
      })}
      data-qa-id={qaId}
      style={wrapperStyle}
    >
      {range(0, 3).map((index) => (
        <SingleDot key={index} circlesEnabled={circlesEnabled ?? false} circleSize={circleSize} />
      ))}
    </div>
  );
};
